<template>
    <router-view></router-view>

</template>

<script>

export default {
  name: 'App',
  components: {}
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  width: 100%;
  background: #000000;
  overflow: hidden;
 font-family: "SourceHanSansCN-Regular", Helvetica;

}
::-webkit-scrollbar {
  display: none !important;
}

</style>
